import React from "react";
import { ImageUploadNoteTemplate } from "themes/common/components";

function ImageUploadNote(props) {
    return <ImageUploadNoteTemplate {...props} />;
}

export default ImageUploadNote;
